#import "../fragments/product-fragment.graphql"

mutation UndeleteProduct($input: ProductUndeleteInput!) {
    productUndelete(input: $input) {
        product {
            ...ProductFragment
        }
    }
}
